
import React from 'react'
import { StyleSheet, Text, View, Platform, ScrollView, TouchableOpacity, Alert, Linking } from 'react-native'
import { Fontisto, AntDesign, Feather, Octicons } from '@expo/vector-icons';
import * as Colors from '../../../Utils/Colors';
import Constant from '../../../Utils/Constant';
import { fontSizeScale, isSubscriptionTierLow, subscriptionEndDateLocal } from '../../../Services/AppManager';
import MyStorage from '../../../Services/MyStorage';
import Loader from '../../common/LoaderComponent/Loader';


const IOS_URL = 'https://support.apple.com/en-us/HT202039';
const AND_URL = 'https://support.google.com/googleplay/answer/7018481?hl=en&co=GENIE.Platform%3DAndroid#zippy=%2Cget-a-refund-on-subscriptions'
const PayPal_URL = 'https://www.paypal.com/va/smarthelp/article/how-do-i-cancel-a-recurring-payment,-subscription,-or-automatic-billing-agreement-i-have-with-a-merchant-faq1067';



class SubscriptionHelp extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoader: false,
        }
    }

    openWebUrl = (url) => {

        if (Platform.OS == 'web') {
            window.open(url, '_blank');

        } else {
            Linking.canOpenURL(url).then((supported) => {
                console.log('Url Support', supported);
                if (supported) {
                    return Linking.openURL(url);
                }
            });
        }
    }


    render() {


        return (
            <ScrollView style={{ backgroundColor: Colors.APP_COLOR_BACKGROUND }}>
                <View style={styles.container}>

                    <View key={'shadowContainer'} style={styles.shadowContainer}>

                        <Text style={styles.subscriptionText}>You have an active subscriptions which automatically renews unless you cancel it.</Text>

                        <View style={{ marginTop: 20 }}>

                            <Text style={styles.subscriptionText}>If you cancel subscription, you can keep using the subscription until the next billing date. You will not get any refund for the cancellation.
                            </Text>

                        </View>
                        {/* <View style={styles.seperator} /> */}
                        <View style={{ marginTop: 20 }}>
                            <Text style={styles.subscriptionText}>How to cancel subscription purchased from iOS <Text onPress={() => this.openWebUrl(IOS_URL)} style={styles.restoreClickabletext}>Click here!</Text></Text>

                        </View>
                        <View style={{ marginTop: 20 }}>

                            <Text style={styles.subscriptionText}>How to cancel subscription purchased from Android <Text onPress={() => this.openWebUrl(AND_URL)} style={styles.restoreClickabletext}>Click here!</Text></Text>
                        </View>
                        <View style={{ marginTop: 20 }}>

                            <Text style={styles.subscriptionText}>How to cancel subscription purchased from PayPal <Text onPress={() => this.openWebUrl(PayPal_URL)} style={styles.restoreClickabletext}>Click here!</Text></Text>
                        </View>

                    </View>

                </View>
                <View style={{ height: 40 }} />
                {this.state.isLoader && <Loader message={'Loading...'} />}

            </ScrollView>
        )
    }
}


export default SubscriptionHelp;

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: Colors.APP_COLOR_BACKGROUND,
        alignItems: 'center'
    },

    shadowContainer: {
        marginTop: fontSizeScale(35),
        backgroundColor: 'white',
        padding: fontSizeScale(15),
        borderRadius: fontSizeScale(10),
        width: '90%',
        shadowColor: 'rgba(0, 0, 0, 0.1)',
        shadowOffset: { width: 0, height: fontSizeScale(3) },
        shadowOpacity: fontSizeScale(3),
        shadowRadius: fontSizeScale(5),
        elevation: fontSizeScale(3),
    },



    subscriptionText: {
        fontSize: fontSizeScale(13),
        color: Colors.APP_DARK_GARY,
        fontFamily: Constant.AppFonts.Roboto.Regular,
        marginTop: fontSizeScale(5),
        lineHeight: fontSizeScale(18)
    },



    seperator: {
        borderBottomColor: Colors.APP_COLOR_BORDER,
        borderBottomWidth: fontSizeScale(2),
        marginLeft: fontSizeScale(-15),
        marginRight: fontSizeScale(-15),
        marginTop: fontSizeScale(15)
    },

    restoreClickabletext: {
        fontSize: 14,
        fontFamily: Constant.AppFonts.Roboto.MediumItalic,
        color: Colors.APP_DARK_GARY,
        // textDecorationLine: 'underline',
        color: '#007AFF'
    },


})

